import videojs from 'video.js';
import 'videojs-contrib-hls';

class HlsPlayer {
    constructor() {
        this.players = [];
        this.init();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.initializePlayers();
        });
    }

    initializePlayers() {
        const videoElements = document.querySelectorAll('.hls-video-player');
        
        videoElements.forEach((videoElement, index) => {
            const playerId = videoElement.id || `hls-player-${index}`;
            videoElement.id = playerId;

            const options = {
                controls: videoElement.dataset.controls !== 'false',
                autoplay: videoElement.dataset.autoplay === 'true' || videoElement.hasAttribute('autoplay'),
                muted: videoElement.dataset.muted === 'true' || videoElement.hasAttribute('muted'),
                loop: videoElement.dataset.loop === 'true' || videoElement.hasAttribute('loop'),
                fluid: true,
                responsive: true,
                preload: 'auto',
                html5: {
                    hls: {
                        enableLowInitialPlaylist: true,
                        smoothQualityChange: true,
                        overrideNative: true
                    }
                }
            };

            const player = videojs(playerId, options);
            
            // Set the HLS source
            const hlsSource = videoElement.dataset.hlsSrc;
            if (hlsSource) {
                player.src({
                    src: hlsSource,
                    type: 'application/vnd.apple.mpegurl'
                });
            }

            // Handle player ready
            player.ready(() => {
                console.log('HLS player ready:', playerId);
                
                // Auto-hide controls for background videos
                if (videoElement.classList.contains('bg-video')) {
                    player.controls(false);
                    player.play().catch(e => {
                        console.log('Autoplay prevented:', e);
                    });
                }
            });

            // Error handling
            player.on('error', (error) => {
                console.error('HLS Player Error:', error);
            });

            this.players.push(player);
        });
    }

    dispose() {
        this.players.forEach(player => {
            if (player && !player.isDisposed()) {
                player.dispose();
            }
        });
        this.players = [];
    }
}

export default HlsPlayer;